import {Suspense, useState} from 'react'
import {Outlet, useLocation, useNavigate} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import ScrollToTop from './componet/scrollTop'
import {AuthInit} from './modules/auth'
import {useEffect} from 'react'
import './fonts/en/web/inter.css'
import './App.css'
import Langs from './Api/SettingLangs'
import {useDispatch} from 'react-redux'
import {actions} from './store/vender/Auth/auth.slice'
import {useSelector} from 'react-redux'
import {RootState} from './store'
import {Stack} from '@mui/material'
import Login from './modules/login'
import JwtService from './utils/TokenServices'
import InvoEn from './modules/orders/View/InvoEn'
import Loading from './componet/loading'
import {ToastContainer, toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {useTranslation} from 'react-i18next'
import RolesPermissions from './Api/rolesPermissions'
import HomeApi from './Api/home'
import Customer from './Api/customer'
import OnboardingWizard from './modules/onboarding/OnboardingWizard'
const App = () => {
  const location = useLocation()
  const {t} = useTranslation()
  const dispatch = useDispatch()
  const store = useSelector((state: RootState) => state.vender)
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingCountries, setIsLoadingCountries] = useState(false)
  const [isLoadingPer, setIsLoadingPer] = useState(false)
  const [isLoadingPackage, setIsLoadingPackage] = useState(!false)
  const [queryParams, setQueryParams] = useState({})
  const [isGetPackages, setIsGetPackages] = useState(true)
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)

    const params = Object.fromEntries(searchParams.entries())

    if (params.status === 'SUCCESS') {
      dispatch(
        actions.setImagesSize({
          ...store.sizeImages,
          pay: {
            ...store.sizeImages.pay,
            is_link_pay: true,
          },
        })
      )
      localStorage.setItem('pay', 'true')
      toast.success(t(params.message))
      HomeApi.imagesSize((res: any) => {
        if (res?.data) {
          dispatch(actions.setImagesSize({...res.data}))
        }
      }, () => {})
    } else if (params.status === 'ERROR') {
      toast.error(t(params.message))
    }

    setQueryParams(params)
  }, [location.search])
  const getAllCountries = () => {
    Customer.getAllCountries((res: any) => {
      dispatch(actions.setAllCountries(res.data))
    }, setIsLoadingCountries)
  }
  useEffect(() => {
    localStorage.setItem('kt_theme_mode_value', 'light')
    localStorage.setItem('kt_theme_mode_value2', 'light')
    getAllCountries()
  }, [])
  const getLangs = () => {
    Langs.getselectedLang((res: any) => {
      if (res.data) {
        localStorage.setItem(
          'langs',
          JSON.stringify(
            res.data.default_language_status === 1 &&
              res.data.store_languages.every((e: any) => e.id !== res.data.default_language.id)
              ? [res.data.default_language, ...res.data.store_languages]
              : res.data.store_languages && res.data.store_languages.length > 0
              ? res.data.store_languages
              : [res.data.default_language]
          )
        )
        const langsCode =
          res.data.default_language_status === 1 &&
          res.data.store_languages.every((e: any) => e.id !== res.data.default_language.id)
            ? [res.data.default_language, ...res.data.store_languages].map((e: any) => e.code)
            : res.data.store_languages && res.data.store_languages.length > 0
            ? [...res.data.store_languages].map((e: any) => e.code)
            : [res.data.default_language.code]
        dispatch(actions.setStoreLangs(langsCode))
        dispatch(actions.setDefLang(res.data.default_language.code))
        dispatch(actions.setLang(res.data.default_language.code))
        dispatch(
          actions.setLangs(
            res.data &&
              res.data.default_language_status === 1 &&
              res.data.store_languages.every((e: any) => e.id !== res.data.default_language.id)
              ? [res.data.default_language, ...res.data.store_languages]
              : res.data.store_languages && res.data.store_languages.length > 0
              ? res.data.store_languages
              : [res.data.default_language]
          )
        )

        dispatch(actions.setLangStatus(res.data.default_language_status))
        dispatch(actions.setRtl(res.data.default_language.is_rtl))
      }
    }, setIsLoading)
    RolesPermissions.getMyPermissions((res: any) => {
      dispatch(actions.setPermissions(res.data))
      console.log(res.data, 'my permissions')
    }, setIsLoadingPer)
    RolesPermissions.getMyPackageFeatures((res: any) => {
      if (res.data) {
        let packages: any = {}
        res.data.map((e: any) => {
          packages[`${e.feature_key}`] = e
        })

        dispatch(actions.setMyPackage(packages))
        setTimeout(() => {
          setIsGetPackages(false)
        }, 1000)
      }
    }, setIsLoadingPackage)
    HomeApi.imagesSize((res: any) => {
      dispatch(actions.setImagesSize({...res.data}))
    }, setIsLoadingPackage)
    if (store.user && location.pathname === '/login') {
      navigate('/dashboard')
    }
    setTimeout(() => {
      setIsLoading(false)
    }, 300)
    dispatch(actions.getStoreImage(localStorage.getItem('storeImage')))
    dispatch(actions.getDomain(localStorage.getItem('domain')))
  }
  useEffect(() => {
    if (store.user) {
      getLangs()
    }
  }, [store.user])
  const [open, setOpen] = useState(false)
  const [locatonPath, setLocationPath] = useState(location.pathname)
  useEffect(() => {
    setLocationPath(location.pathname)
    if (
      location.pathname.includes('/catalog/sub-category') &&
      location.pathname.includes('/edit-category')
    ) {
      navigate(`/catalog/sub-category/${location.pathname.split('/')[3]}`)
    } else if (location.pathname.includes('/add-category/add-sub-category')) {
      navigate(`/catalog/add-sub-category`)
    }
    if (!isLoadingPackage) {
      const incomplete =
        store.user &&
        store.sizeImages &&
        !store.sizeImages.is_onboarding_complete
      setOpen(Boolean(incomplete))
    }
  }, [location, isLoadingPackage, store.user, store.sizeImages])

  return (
    <>
      <ToastContainer />
      <Stack
        lang={store.lang}
        overflow={isLoading ? 'hidden' : 'revert'}
        position={'relative'}
        dir={store.isRtl === 0 ? 'ltr' : 'rtl'}
        height={isLoading ? '100vh' : 'auto'}
      >
        {isLoadingPer && (
          <Stack width={'100vw'} zIndex={'200'} height={'100%'} top='0' position={'absolute'}>
            <Loading />
          </Stack>
        )}

        <Suspense fallback={<LayoutSplashScreen />}>
          <I18nProvider>
            {JwtService.getToken() ? (
              <>
                <LayoutProvider>
                  <AuthInit>
                    <Outlet />
                    {!isGetPackages &&
                      !isLoadingPackage &&
                      store.sizeImages &&
                      !store.sizeImages.is_onboarding_complete && (
                        <OnboardingWizard
                          open={open}
                          onFinished={() => {
                            setOpen(false)
                          }}
                        />
                      )}
                    <MasterInit />
                  </AuthInit>
                  <ScrollToTop />
                </LayoutProvider>
              </>
            ) : (
              <LayoutProvider>
                <AuthInit>
                  <Login />
                  <MasterInit />
                </AuthInit>
              </LayoutProvider>
            )}
          </I18nProvider>
        </Suspense>
      </Stack>
    </>
  )
}

export {App}
